import Carousel from '../components/Carousel'
import Contact from '../components/Contact'
import Feedbacks from '../components/Feedbacks'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import IdeaSectionAbout from '../section/IdeaSectionAbout'
import WebContentHero from '../section/WebContentHero'
import PartnersLogos from '../components/PartnersLogos'
import React from 'react'
import { Helmet } from 'react-helmet';
import IdeaContentSect from '../section/IdeaContentSect'


function WebContentWriting() {
  return (
    <div className="relative z-0 bg-[#060816]">
        <Helmet>
<title>Web Content Writing - The Designsinc.</title>
</Helmet>
    <div>
      <Navbar />
      <div>
        {/** About Section */}
       <WebContentHero />
       {/**Slider logos company */}
       <PartnersLogos />

        {/**idea section and btns */}
        <IdeaContentSect />

        {/** Testimonials */}
        <div className="">
        <Feedbacks  />
        </div>
        {/** contact section */}
        <div className='relative z-0'>
      <Contact />
    
    </div>
      </div>
    </div>

    <Footer />
  </div>
  )
}

export default WebContentWriting